<template>
    <div :class="[{ disabled: isLoading }, 'position-relative']">
        <div
            v-if="isLoading"
            class="spinner-holder"
        >
            <ui-spinner />
        </div>

        <slot
            :loadMore="loadMore"
            :messages="messages"
            :showLoadMore="showLoadMore"
            :totalUnread="totalUnread"
        />
    </div>
</template>

<script>
import axios from 'axios';

import UiSpinner from '../ui/spinner.vue';

export default {
    name: 'MessagesOverview',
    components: {
        UiSpinner,
    },
    props: {
        hospitalId: {
            type: Number,
            default: null,
        },
        url: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            debounce: null,
            isLoading: false,
            messages: [],
            page: 1,
            totalUnread: null,
        };
    },
    created() {
        this.fetch();
    },
    computed: {
        showLoadMore() {
            return this.messages.length < this.totalUnread;
        },
    },
    methods: {
        async fetch() {
            if (!this.url) return;

            this.isLoading = true;

            const { data } = await axios.get(this.url, {
                    params: {
                        page: this.page,
                    },
                },
            );

            this.messages = this.messages.concat(data.messages);
            this.totalUnread = data.total_unread;

            this.isLoading = false;
        },

        loadMore() {
            this.page = this.page + 1;

            this.fetch();
        },
    },
}
</script>

<style lang="scss" scoped>
    .spinner-holder {
        z-index: 2;
    }

    .message {
        &:hover {
            opacity: 0.8;
        }
    }
</style>
